export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';
export const LIST_LANGUAGES = 'LIST_LANGUAGES';